import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonFieldService} from "../../../../../../services/common/common-field.service";
import {AllocationRequest} from "../../../../../../model/clearing/allocation/allocation-request";
import {AccountType} from "../../../../../../model/exchange/account-type";
import {ClearingAllocationService} from "../../../../../../services/clearing/clearing-allocation.service";
import {AllocationSplitRequest} from "../../../../../../model/clearing/allocation/allocation-split-request";
import {SplitAllocationFormBaseComponent} from "../split-allocation-form-base.component";
import {Trade} from "../../../../../../model/clearing/trade";
import {ExchangeContractService} from "../../../../../../services/exchange/exchange-contract.service";
import {ThemeService} from "../../../../../../services/tools/theme.service";
import {ClearingTradeInfoService} from "../../../../../../services/clearing/clearing-trade-info.service";
import {ClearingInfoLoadRequest} from "../../../../../../model/clearing/clearing-info-load-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../../../../model/api/api-validation";
import {ClearingSelectionSummary} from "../../../../../../model/clearing/clearing-selection-summary";
import {AppConfigService} from "../../../../../../services/app-config.service";
import {FieldRecord} from "../../../../../../model/api/field-record";
import {ClearingHouse} from "../../../../../../model/exchange/clearing-house";
import {FieldRequest} from "../../../../../../model/api/field-request";
import {AccountDefinition} from "../../../../../../model/customer/account-definition";
import {FormFieldConfig} from "../../../../../../model/api/form-field-config";
import {StringUtils} from "../../../../../../utils/stringUtils";
import {FieldsService} from "../../../../../../services/common/fields-service";
import {CcStorageService} from "../../../../../../services/common/cc-storage.service";
import Side = Trade.Side;
import OpenClose = AccountDefinition.OpenClose;
import CallPut = Trade.CallPut;
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-clearing-create-order-form',
  templateUrl: './create-order-form.component.html',
  styleUrls: ['../split-allocation-form-base.component.scss', '../allocation-form-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateOrderFormComponent extends SplitAllocationFormBaseComponent {

  clearingHouse: FieldRecord<ClearingHouse>[] = [];
  sideOptions: FieldRecord<any>[];

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              allocationService: ClearingAllocationService,
              exchangeContractService: ExchangeContractService,
              commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              themeService: ThemeService,
              private clearingTradeInfoService: ClearingTradeInfoService,
              storageService: CcStorageService,
              fieldsService: FieldsService) {
    super(el, cdref,
      allocationService,
      exchangeContractService,
      commonFieldService,
      appConfigService,
      messageService,
      confirmationService,
      translateService,
      themeService,
      storageService,
      fieldsService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.create_order');
  }

  public open(): void {
    this.refreshConfig();
    this.ccFormDialog.reloadFieldValueMap();
    // this.formLoading = true;
    // this.allocationService.getSignificantTrades(selectedIds).subscribe(validation => {
    //   if (validation.success) {
    this.show();
    const allocationInProgress = new AllocationRequest();
    allocationInProgress.accountTypeCode = AccountType.GIVE_UP_CODE;
    allocationInProgress.tradeIds = [];
    allocationInProgress.businessDate = new Date(new Date().setHours(1, 0, 0, 0));
    allocationInProgress.clearingDate = new Date(new Date().setHours(1, 0, 0, 0));
    allocationInProgress.clearingHouse = undefined;
    allocationInProgress.exchangeCode = undefined;
    allocationInProgress.side = Side.BUY;
    allocationInProgress.tradeType = 'REG';
    allocationInProgress.contractCode = undefined;
    allocationInProgress.contractUnit = undefined;
    allocationInProgress.contractVersion = undefined;
    allocationInProgress.tradingEnvironment = undefined;
    allocationInProgress.maturity = undefined;
    allocationInProgress.owner = this.owners && this.owners.length > 0 ? this.owners[0].value.code : undefined;
    allocationInProgress.volume = 0;
    allocationInProgress.openClose = OpenClose.NO;
    allocationInProgress.callPut = CallPut.NONE;
    allocationInProgress.strike = 0;
    allocationInProgress.customOrderReference = undefined;
    allocationInProgress.accountTypeCode = AccountType.GIVE_UP_CODE;
    // this.contracts = [{text:firstTrade.contractCode, id:allocationInProgress.contractId, value: undefined}];
    // console.log("------> allocationInProgress " + JSON.stringify(allocationInProgress));
    const allocationSplit: AllocationSplitRequest = {
      allocation: allocationInProgress.volume,
      accountTypeCode: AccountType.GIVE_UP_CODE,
      clearingHouse: undefined,
      exchangeCode: undefined,
      execTrader: undefined,
    };
    allocationInProgress.allocations.push(allocationSplit);
    allocationInProgress['formContractsCodes'] = [];
    this.openWithRecord(allocationInProgress);
    // } else {
    //   this.errorMessage(validation.message);
    //   this.loadingProgressValue = 100;
    // }
    // this.formLoading = false;
    // });
  }

  public openWithRecord(newFormRecord: AllocationRequest): void {
    this.formRecord = newFormRecord;
    this.formContractsCodes = newFormRecord['formContractsCodes'];
    // this.refreshConfig();
    // this.ccFormDialog.reloadFieldValueMap();
    // this.refreshConfig();
    // this.ccFormDialog.reloadFieldValueMap();
    // this.loadingProgressValue = 0;
    // this.loadingProgressValue = 0;
    this.loadData();
    // this.filterExchanges();
    // this.filterTradingEnvs();
    // this.filterCustomers();
    // this.filterAccountTypes();
    // this.filterContracts();
    this.loadFooterInfos(this.formRecord.tradeIds);
    this.show();
  }

  save() {
    this.formLoading = true;
    this.formRecord.traders = undefined;
    this.formRecord.allocations.forEach(alloc => {
      alloc.clearingHouse = this.formRecord.exchangeCode;
      alloc.clearingHouse = this.exchanges
        .find(exchange => exchange.value
          && exchange.value.code === this.formRecord.exchangeCode).value.clearingHouse;
      if (this.manageGiveUpMssg23()) {
        alloc.broker = alloc.giveUpMessage3;
      }
    });
    this.formRecord.clearingHouse = this.exchanges
      .find(exchange => exchange.value
        && exchange.value.code === this.formRecord.exchangeCode).value.clearingHouse;
    this.allocationService.splitAllocationRequest(this.formRecord).subscribe(validation => {
      if (validation.success) {
        this.onSavedForm.emit({taskId: validation.item, formRecord: Object.assign({}, this.formRecord)});
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  protected getSelectionSummary(summaryRequest: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionSummary[]>> {
    return this.clearingTradeInfoService.getSelectionSummary(summaryRequest);
  }

  loadData() {
    super.loadData();

    this.sideOptions = [];
    for (let key in Trade.Side) {
      this.sideOptions.push(new FieldRecord(key, StringUtils.humanize(key)))
    }

    this.fieldsService.loadField(this.clearingHouse, () => this.commonFieldService.getClearingHouses(FieldRequest.DEFAULT()), this.tracker, (records) => {
      this.refreshFieldData();
    });
  }

  protected refreshConfig() {
    super.refreshConfig();
    this.formConfig[0].fields[0] =
      {
        column: 2,
        type: TYPE.NONE,
      };
    this.formConfig[0].fields[1] =
      {
        field: 'owner',
        required: true,
        column: 2,
        optionValue: 'text',
        type: TYPE.DROPDOWN,
        options: () => this.owners,
        changed: event => {
          this.filterCustomers();
        },
        hidden: () => this.owners.length === 1,
      };
    this.formConfig[0].fields[2] =
      {
        // @ts-ignore
        field: 'side',
        required: true,
        column: 2,
        type: TYPE.DROPDOWN,
        options: () => this.sideOptions,
      };
    this.formConfig[0].fields[3] =
      {
        field: 'exchangeCode',
        required: true,
        icon: (id: string) => {
          if (this.exchanges) {
            const exchField = this.exchanges.find(exchange => exchange.value && exchange.value.code === id);
            if (exchField && exchField.value)
              return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          }
          return 'fas fa-globe-europe';
        },
        filter: true,
        column: 2,
        type: TYPE.DROPDOWN,
        options: () => this.exchanges,
        changed: event => {
          this.formRecord.exchangeCode = event.value;
          const accountCode = this.formRecord.accountCode;
          this.formRecord.accountCode = undefined;
          this.filterExchanges();
          this.filterCustomers();
        }
      };
    this.formConfig[0].fields[4].required = true;
  }

  protected ownersLoaded() {
    super.ownersLoaded();
    if (!this.formRecord.owner)
      this.formRecord.owner = this.owners && this.owners.length > 0 ? this.owners[0].value.code : undefined;

    this.ccFormDialog.reloadFieldValueMap();
    this.markForCheck();
  }
}
